import type { StudioBadge } from '#~/routes/scaffold/header/switcher/types.js';

/**
 * The user's permission level in a Studio as a word ("Owner", "Producer") from
 * the registry role chip ("OWNER", "PRODUCER"). Undefined when no role is
 * reported, so callers omit it rather than guess.
 */
export const permissionLevelLabel = (
  roles: readonly Pick<StudioBadge, 'label'>[]
): string | undefined => {
  const label = roles[0]?.label.trim();
  if (label === undefined || label.length === 0) return undefined;
  return `${label.charAt(0)}${label.slice(1).toLowerCase()}`;
};
